import ajax from '@/utils/ajax'

/**
 * @module 用户数据统计
 */

// 营销任务枚举值
export const taskList = params => ajax.post('/marketStatistics/taskList', params)

// 用户转换情况用户转换情况 （梯形）
export const userStatistics = params => ajax.post('/marketStatistics/userStatistics', params)

// 券营销成本(第一个饼图)
export const couponCost = params => ajax.post('/marketStatistics/couponCost', params)

// 目标画像人群贡献订单（第二个饼图）
export const userOrder = params => ajax.post('/marketStatistics/userOrder', params)

// 目标用户营销效果对比分析（柱状图）
export const effectData = params => ajax.post('/marketStatistics/effectData', params)

// 目标用户营销效果对比分析导出（柱状图）
export const effectDataExport = params => ajax.post('/marketStatistics/effectDataExport', params)

// 任务数据日趋势（数据汇总）
export const taskDayDataSum = params => ajax.post('/marketStatistics/taskDayDataSum', params)

// 任务数据日趋势导出（数据汇总）
export const sumDayDataExport = params => ajax.post('/marketStatistics/sumDayDataExport', params)

// 任务数据日趋势（折线图）
export const taskDayData = params => ajax.post('/marketStatistics/taskDayData', params)

// 任务日趋势数据导出
export const dayDataExport = params => ajax.post('/marketStatistics/dayDataExport', params)
 